export enum Interval {
	DAILY = "Daily",
	MONTHLY = "Monthly",
}
